<div class="risk-loader">
  <div class="risk-loader__circle-wrap">
    <!-- SVG arc ring (240×240, sits behind/around white circle) -->
    <svg class="risk-loader__ring" viewBox="0 0 240 240" width="240" height="240">
      <!-- optional track circle (faint) -->
      <circle cx="120" cy="120" r="114" fill="none" class="risk-loader__track" stroke-width="6" />
      <!-- animated arc -->
      <circle cx="120" cy="120" r="114" fill="none" class="risk-loader__arc" stroke-width="6"
        stroke-linecap="round" stroke-dasharray="537 716" />
    </svg>
    <!-- white circle + icon (keyed by currentIndex to re-trigger iconAppear animation) -->
    <div class="risk-loader__circle">
      @for (slot of [currentIndex()]; track slot) {
        <activar-icon class="risk-loader__icon" [name]="icon()" size="96px" />
      }
    </div>
  </div>
  <!-- label below circle -->
  <p class="risk-loader__label">{{ label() }}</p>
  <!-- subtitle (optional) -->
  @if (subtitle()) {
    <p class="risk-loader__subtitle">{{ subtitle() }}</p>
  }
</div>
